export const NOTIFICATION_TAB_UPDATES = 'updates';
export const NOTIFICATION_TAB_MESSAGES = 'messages';
export const TOP_BAR_HEIGHT = 69; // Main Navigation Header Height
export const SCROLL_THRESHOLD = 50; // Scroll Threshold
